/* unplugin-vue-components disabled */// extracted by css-extract-rspack-plugin
export default {"couponRulesPopupContainer":"coupon-rules-popup_couponRulesPopupContainer__aUTq5"};